import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { AuthActions } from "../../auth/store/actions";
import { Strings } from "../../../strings/strings";

@Component({
    selector: "app-role-assignment-required",
    templateUrl: "./role-assignment-required.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class RoleAssignmentRequiredComponent {
    private readonly globalStore = inject(Store);
    readonly Strings = Strings;

    logout(): void {
        this.globalStore.dispatch(AuthActions.logout());
    }
}
